import * as products from '@appStore/products/actions/products.actions';
import * as agreements from '@appStore/products/actions/agreement.actions';
import * as serviceAgreements from '@appStore/products/actions/service-agreements.actions';

export * from '@appStore/products/actions/products.actions';
export * from '@appStore/products/actions/agreement.actions'
export * from '@appStore/products/actions/service-agreements.actions'

export const ActionTypes = { 
    ...products.ProductsActionTypes, 
    ...agreements.AgreementActionTypes,
    ...serviceAgreements.ServiceAgreementsActionTypes};

export type Actions = 
    products.ProductsActions | 
    agreements.AgreementActions |
    serviceAgreements.ServiceAgreementsActions;
